import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_AUTH,
  STORE_AUTH_FETCH_UPDATE_PASSWORD,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'
import { ErrorStore, Password } from '@types'
import { createGenericSlice, GenericState } from 'stores/generics/create-slice'
import { createReducers, ExtraReducers } from 'stores/generics/create-reducers'

import { Payload } from 'stores'

export type PasswordState = Password

type State = GenericState<PasswordState>

export const initialState: State = {
  data: {
    email: '',
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchUpdatePassword = createAsyncThunk<
  PasswordState,
  Promise<Password>,
  Payload
>(
  STORE_AUTH_FETCH_UPDATE_PASSWORD,
  async (promise: Promise<Password>, { rejectWithValue }) => {
    try {
      const response = await promise
      return response
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  PasswordState,
  Password,
  Payload
>(fetchUpdatePassword, initialState.data)

const passwordSlice = createGenericSlice({
  name: STORE_AUTH,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = passwordSlice

const { clear } = actions

export { clear }

export default reducer
